// admin/src/pages/GatewayMonitoring/gatewayPermissions.js
'use strict';

/**
 * Exact permission strings enforced by the Gateway Monitoring administrative backend.
 * Evaluated without any role-name strings for regular users.
 */
export const GATEWAY_PERMISSIONS = {
  READ: 'Gateway Monitoring-Gateways-GatewaysRead',
  CREATE: 'Gateway Monitoring-Gateways-GatewaysCreate',
  UPDATE: 'Gateway Monitoring-Gateways-GatewaysUpdate',
  DELETE: 'Gateway Monitoring-Gateways-GatewaysDelete',
};

/**
 * Determines whether the authenticated principal is an organization owner.
 * Genuine organization owners: user.superadmin flag, or (user.nameOfOrg && !user.roleId && !user.SuperAdminId).
 * Regular users are decided ONLY by exact permission strings in user.permissions without role-name checks.
 *
 * @param {Object} user - Stored user principal
 * @returns {boolean}
 */
export function isOrganizationOwner(user) {
  if (!user || typeof user !== 'object') return false;
  return Boolean(
    user.superadmin ||
    (user.nameOfOrg && !user.roleId && !user.SuperAdminId)
  );
}

/**
 * Checks if the user is authorized for an administrative Gateway Monitoring operation.
 * - Genuine organization owners bypass permission checks.
 * - All other users MUST possess the exact permission string in user.permissions.
 * Never gates users by role name.
 *
 * @param {Object} user - Stored user principal
 * @param {string} permission - Exact permission string
 * @returns {boolean}
 */
export function hasGatewayPermission(user, permission) {
  if (!user || typeof user !== 'object') return false;
  if (isOrganizationOwner(user)) return true;
  if (!permission || typeof permission !== 'string') return false;
  return Array.isArray(user.permissions) && user.permissions.includes(permission);
}
